import { render } from "./partial-command-action-force-dialog-confirmation.vue?vue&type=template&id=9b12e8b8&ts=true"
import script from "./partial-command-action-force-dialog-confirmation.vue?vue&type=script&lang=ts"
export * from "./partial-command-action-force-dialog-confirmation.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__